<template>
	<div id="home" v-scroll="onScroll" v-resize="onResize">
		<app-sidebar
		:active="active"
		:items="items"
		@change-active="changeActive"
		@close-modal="closeModal"
		/>
		<router-view></router-view>
		<app-contact
		:information="information"
		/>
		<app-footer
		:window-size="windowSize"
		:logos-company="logosCompany"
		:links-footer="linksFooter"
		/>
	</div>
</template>

<script>
import appSidebar from '@/components/home/app-sidebar';
import appContact from '@/components/home/app-contact';
import appFooter from '@/components/home/app-footer';

function onScroll() {
	this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
}

function onResize() {
	this.windowSize = { x: window.innerWidth, y: window.innerHeight };
}

function changeActive() {
	this.active = !this.active;
}

function closeModal() {
	if (this.$route.name === 'page-pillars') {
		this.$router.push({ name: 'page-home' });
		this.active = false;
	}
	this.active = false;
}

function data() {
	return {
		active: false,
		offsetTop: 0,
		windowSize: {
			x: 0,
			y: 0,
		},
		items: [
			{
				id: 1,
				name: '¿QUIÉNES SOMOS?',
				href: '#description',
			},
			{
				id: 2,
				name: 'PILARES RUNN',
				link: 'pillars',
			},
			{
				id: 3,
				name: 'NUESTROS PRODUCTOS',
				href: '#our-products',
			},
			{
				id: 4,
				name: 'NUESTRO TEAM',
				href: '#our-team',
			},
			{
				id: 5,
				name: 'CONTÁCTANOS',
				href: '#app-contact',
			},
		],
		information: [
			{
				id: 1,
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/pin.svg',
				name: 'Calle Independencia 120 Miraflores- Lima - Perú',
			},
			{
				id: 2,
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/phone+(1).svg',
				name: '(01)543-6575',
			},
			{
				id: 3,
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/email.svg',
				name: 'info@apprunn.com',
			},
		],
		logosCompany: [
			{
				id: 1,
				name: 'Gittrack',
				logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/gittrack.svg',
				width: '80px',
			},
			{
				id: 2,
				name: 'japisale',
				logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/japisale.svg',
				width: '86px',
			},
			{
				id: 3,
				name: 'quipu',
				logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/quipu.svg',
				width: '73px',
			},
			{
				id: 4,
				name: 'controlinn',
				logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/controlinn.svg',
				width: '96px',
			},
			{
				id: 5,
				name: 'smart',
				logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/smart.svg',
				width: '80px',
			},
			{
				id: 6,
				name: 'perudatos',
				logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/perudatos.svg',
				width: '83px',
			},
			{
				id: 7,
				name: 'feedbackinn',
				logo: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/feedbackinn.svg',
				width: '85px',
			},
		],
		linksFooter: [
			{
				id: 1,
				name: 'NOSOTROS',
				items: [
					{
						id: 1,
						name: '¿Quienes somos?',
						href: '#description',
					},
					{
						id: 2,
						name: 'Nuestro Equipo',
						href: '#our-team',
					},
					{
						id: 3,
						name: 'Nuestros productos',
						href: '#our-products',
					},
				],
			},
			{
				id: 2,
				name: 'BLOG',
				items: [
					{
						id: 1,
						name: 'Tema 1',
						href: '',
					},
				],
			},
		],
	};
}

export default {
	name: 'page-layout',
	data,
	components: {
		appContact,
		appFooter,
		appSidebar,
	},
	methods: {
		changeActive,
		closeModal,
		onScroll,
		onResize,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/page-layout.vue